var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLightning = function SvgLightning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39.64 66.312",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.066,32.139a3.852,3.852,0,0,0-2.829-1.307l-10.525,0L51.051,9.353a3.781,3.781,0,0,0-2.829-4.28A3.5,3.5,0,0,0,47.349,5a4.08,4.08,0,0,0-3.484,1.959L24.056,38.525a3.907,3.907,0,0,0-.289,3.773,3.631,3.631,0,0,0,3.41,2.1H37.7L34.36,65.957a3.847,3.847,0,0,0,2.829,4.28,3.476,3.476,0,0,0,.87.074,4.29,4.29,0,0,0,3.555-1.959L61.208,37a4.011,4.011,0,0,0,.726-1.814,3.638,3.638,0,0,0-.867-3.05ZM40.747,59.715l2.684-17.561a2.659,2.659,0,0,0-.581-2.177,2.7,2.7,0,0,0-2.033-.944H30.006l14.658-23.44L41.98,33.157a2.659,2.659,0,0,0,.581,2.177,2.7,2.7,0,0,0,2.033.944H55.405Z",
    transform: "translate(-22.865 -4.499)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLightning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lightning.9f5ab27c.svg";
export { ForwardRef as ReactComponent };